import { Result } from 'core/infrastructure';
import { Preconditions } from 'core/infrastructure-next';
import { Permission, TicketLineDTO, TicketLineStatus } from 'core/api';
import { Command } from 'pos/common';
import * as SalesStore from 'pos/modules/main/SalesStore';
import { Res } from 'core/api';
import { Message } from 'core/ui-next/modal';

declare global {
	interface CommandType {
		prepareTicketLineAgain: (line: TicketLineDTO) => Promise<Result>
	}
}

Command.register('prepareTicketLineAgain', Preconditions.ensure(Permission.Ticket_PrepareTicketAgain), async (line: TicketLineDTO): Promise<Result> => {
	if (line.Status === TicketLineStatus.New || line.HasBeenRequested) {
		await Message.show(Res.Msg.MSG_TICKET_TICKET_LINE_CANNOT_BE_PREPARED_AGAIN());
		return Result.error();
	}

	await SalesStore.prepareLineAgain(line.Id);
	return Result.ok();

});